import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/services/auth.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ERROR_MSG, SUCCESS_MSG } from 'src/app/shared/errorMessages';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.scss']
})
export class ChangePasswordComponent implements OnInit {
  changePassForm: FormGroup;
  formErrors = {
    'oldPassword': '',
    'newPassword': ''
  };

  validationMessages = {
    'oldPassword': {
      'required': 'Por favor ingrese su contraseña'
    },
    'newPassword': {
      'required': 'Por favor ingrese su nueva contraseña'
    }
  };
  confirmPassMsg: string = 'Ingrese nuevamente la contraseña';


  constructor(private fb: FormBuilder,
    private dialogRef: MatDialogRef<ChangePasswordComponent>,
    private authService: AuthService,
    private _snackBar: MatSnackBar) {
    this.createForm();
  }

  ngOnInit(): void {
  }

  createForm() {
    this.changePassForm = this.fb.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required]]
    });

    this.changePassForm.valueChanges
      .subscribe(data => this.onValueChanged(data));

    this.onValueChanged();
  }

  onValueChanged(data?: any) {
    if (!this.changePassForm) { return; }
    const form = this.changePassForm;
    for (const field in this.formErrors) {
      if (this.formErrors.hasOwnProperty(field)) {
        // clear previous error message (if any)
        this.formErrors[field] = '';
        const control = form.get(field);
        if (control && control.dirty && !control.valid) {
          const messages = this.validationMessages[field];
          for (const key in control.errors) {
            if (control.errors.hasOwnProperty(key)) {
              this.formErrors[field] += messages[key] + ' ';
            }
          }
        }
      }
    }
  }

  verifyPassword(value: string) {
    if (value !== this.changePassForm.value.newPassword) {
      this.confirmPassMsg = "Las contraseñas no coinciden";
    } else {
      this.confirmPassMsg = "";
    }
  }

  save() {
    this.authService.changePassword(this.changePassForm.value.oldPassword, this.changePassForm.value.newPassword).then(res => {
      if (res.success) {
        this._snackBar.open(SUCCESS_MSG['SUCCESS_UPDATED'], null, {
          duration: 3000,
        });
        this.dialogRef.close();
        location.reload();
      } else {
        this._snackBar.open(res.data, null, {
          duration: 3000,
        });
      }
    }).catch(error => {
      this._snackBar.open(ERROR_MSG[error.code], null, {
        duration: 3000,
      });
    });
  }

}
